import {useTranslation} from "react-i18next";

const TriggerBase = ({trigger}) => {
    const { t } = useTranslation();
    return (
        <>
            <tr>
                <td colSpan={2} className="box-name">{t("stateControllerService.inputTrigger.inputTrigger")}: {t("stateControllerService.inputTrigger." + trigger.$type)}</td>
            </tr>
            <tr>
                <td>{t("stateControllerService.activated")}</td>
                <td>{trigger.active ? t("allgemein.ja") : t("allgemein.nein")}</td>
            </tr>
        </>
    )
}

export default TriggerBase
